import {
  FETCH_ICDS_REQUEST, FETCH_ICDS_SUCCESS, FETCH_ICDS_FAILURE,
  CREATE_ICD_SUCCESS, UPDATE_ICD_SUCCESS, DELETE_ICD_SUCCESS,
  FETCH_ICD_RULES_SUCCESS
} from '../actions/icdActions';

const initialState = {
  icds: [],
  rules: [],
  loading: false,
  error: null,
};

export default function icdReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ICDS_REQUEST:
      return { ...state, loading: true };
    case FETCH_ICDS_SUCCESS:
      return { ...state, loading: false, icds: action.payload };
    case FETCH_ICDS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CREATE_ICD_SUCCESS:
      return { ...state, icds: [...state.icds, action.payload] };
    case UPDATE_ICD_SUCCESS:
      return {
        ...state,
        icds: state.icds.map((icd) => (icd.id === action.payload.id ? action.payload : icd)),
      };
    case DELETE_ICD_SUCCESS:
      return { ...state, icds: state.icds.filter((icd) => icd.id !== action.payload) };
    case FETCH_ICD_RULES_SUCCESS:
      return { ...state, rules: action.payload };
    default:
      return state;
  }
}
